<template>
  <div class="change-pwd__box">
    <el-form
      ref="changePwd"
      :rules="rules"
      label-position="top"
      :model="formData"
      class="change-pwd__form"
      @submit.native.prevent
    >
      <el-form-item label="原密码:" prop="oldAccountPwd" type="input">
        <el-input v-model="formData.oldAccountPwd" class="password__input" type="password"></el-input>
      </el-form-item>
      <el-form-item label="新密码:" prop="newAccountPwd" type="input">
        <el-input v-model="formData.newAccountPwd" class="password__input" type="password"></el-input>
        <span class="pwd-input__tips">*8-16位 必须包含大小写和数字组合</span>
      </el-form-item>
      <el-form-item class="submit__btn">
        <el-button @click="$_submit" class="change-pwd__btn">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import * as Utils from "@/plugins/utils";
import * as TYPES from "@/store/types";
import md5 from "md5";
import { mapActions } from "vuex";
import { validPwd } from '@/plugins/passwordValid'

export default {
  name: "change-pwd",
  data() {
    return {
      formData: {
        oldAccountPwd: "",
        newAccountPwd: ""
      },
      rules: {
        oldAccountPwd: [{ required: true, message: "请输入旧密码" }],
        newAccountPwd: [
          { required: true, message: "请输入新密码" },
          { validator: validPwd, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    $_submit() {
      const self = this;
      this.$refs["changePwd"].validate(valid => {
        if (valid) {
          const aid = self.$store.getters.aid;

          self.$service
            .post("updatePwd", {
              aid,
              oldAccountPwd: md5(self.formData.oldAccountPwd),
              newAccountPwd: md5(self.formData.newAccountPwd)
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.logout();
                    window.location.replace("/login.html");
                  }
                });
              }
            });
        }
      });
    },
    ...mapActions({
      logout: TYPES.LOGOUT
    })
  }
};
</script>

<style lang="scss" scoped>
.change-pwd__btn {
  width: 80px;
  height: 30px;
  background-color: #1895dd;
  border-radius: 4px;
  &:hover {
    background-color: #4188d0;
  }
  &:focus {
    background-color: #276eb6;
  }
}
.change-pwd__form {
  text-align: left;
  line-height: 32px;
  padding: 0 20px;
  .pwd-input__tips {
    display: block;
    color: #aaa;
    font-size: 12px;
    padding-top: 6px;
  }
}
.submit__btn {
  text-align: center;
}
</style>
<style lang="scss">
.change-pwd__form {
  .el-form-item {
    .el-form-item__label {
      font-size: 13px;
      color: #535353;
    }
    &.is-required {
      .el-form-item__label::before {
        content: "";
      }
    }
    .el-input__inner {
      width: 210px;
      height: 34px;
      padding: 4px;
      border: 1px solid #a6babf;
      color: #000;
      margin-top: 4px;
      &:focus {
        border-color: #1895dd;
      }
    }
  }
}
</style>



